import { css } from "@emotion/css";
import { theme } from "assets/theme";

export const ScreenContainerStyle = css`
  width: 100%;
  margin: auto;
  padding: 0px;
  display: grid;
  grid-template-columns: auto 400px;
  gap: 16px;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const TranscriptSummaryStyle = css`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  @media (max-width: 768px) {
    height: 100%;
  }
`;

export const FullTranscriptStyle = css`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  margin: auto;
  padding: 14px 36px;
  border-left: 1px solid ${theme.colors.border.primary};
  display: column;
  @media (max-width: 768px) {
    height: 100%;
    padding: 0px;
    border-left: none;
  }
`;

export const LabelContainerStyle = css`
  margin-bottom: 30px;
`;
export const LabelStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  margin-bottom: 5px;
`;
export const LabelIconStyle = {
  width: "16px",
  height: "16px",
  marginRight: "5px",
};
export const MeetingGridStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
export const AttendeeStyle = (expanded: boolean) => css`
  width: 100%;
  height: 60px;
  border-radius: 16px;
  border: 1px solid ${theme.colors.border.primary};

  background-color: ${theme.colors.background.secondary};

  backdrop-filter: blur(1.5px);
  padding: 0px 16px;
  overflow: hidden;
  transition: height 0.3s;
  ${expanded ? "height: 400px;" : ""}
  margin-bottom: 16px;
`;
export const AttendeeLeftStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`;
export const AttendeeHeaderStyle = css`
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 8px 0px;
  cursor: pointer;
`;
export const AttendeeCaretIconStyle = {
  width: "24px",
  height: "24px",
};
export const AttendeeInfoBodyStyle = css`
  padding: 0px 16px;
  height: calc(100% - 60px);
  overflow-y: auto;
  padding-bottom: 16px;
`;

// meetings
export const MeetingCalendarStyle = css`
  width: 100%;
  max-width: 1088px;
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const CalendarContainerStyle = css`
  display: inline-block;
  width: 35%;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const TranscriptStyle = css`
  width: 100%;
  max-width: 768px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
export const TranscriptFilterContainerStyle = css`
  display: inline-block;
  width: 35%;
`;
export const CalendarContainerMobileStyle = css`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const MeetingItemStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 16px 0px;
  width: 100%;
`;

export const MeetingItemRightStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 30%;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
  }
`;

export const DotIconStyle = {
  width: "4px",
  height: "4px",
  marginRight: "4px",
  marginLeft: "4px",
};

export const MeetingListCardStyle = css``;
